import React, { useState, useEffect } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { getPrettyPrice } from '../../helpers';
import { fetchProductByHandle } from '../../actions';
import { ArrowRight } from '../parts/svg.jsx';
import { find } from 'lodash';
import classNames from 'classnames';

const Product = ({product, visible, fetchProductByHandle, ...props}) => {
  const [ hovered, setHovered ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const match = useRouteMatch();

  useEffect(() => {
    if(!product){
      fetchProductByHandle(props.handle);
    }
  }, []);

  if(!product){
    return null
  }

  const _handleMouseEnter = e => {
    setHovered(true);

    if(props.onMouseEnter){
      props.onMouseEnter(e);
    }
  }
  const _handleMouseLeave = e => {
    setHovered(false);
    if(props.onMouseLeave){
      props.onMouseLeave(e);
    }
  }

  const image = hovered ? product.images[1] : product.images[0];

  return (
    <Link
      to={`${match.path}/${product.handle}`}
      className={classNames('product', {
        'product--ready': ready,
        'product--visible': visible
      })}
      {...props}
      onMouseEnter={e => _handleMouseEnter(e)}
      onMouseLeave={e => _handleMouseLeave(e)}
      >
      <div className="product__image">
        {image &&
          <img src={image.src} />
        }
      </div>
      {props.showTitle &&
        <div className="product__title">
        {product.title}
        </div>
      }
      {(product.description && props.type !== "teaser") &&
        <div className="product__description">
          <div className="product__type">
          {product.productType}
          </div>
          <div className="description" dangerouslySetInnerHTML={{__html: product.descriptionHtml }} />
        </div>
      }
      <div className="product__footer">
        <div className="product__price">
          {product.variants && product.variants[0].price &&
            getPrettyPrice(product.variants[0].price)
          }
        </div>
        <div className="product__link">
          <div>Purchase</div>
        </div>
      </div>
    </Link>
  );
}


const mapStateToProps = (state, ownProps) => {
  if(ownProps.product){
    return ownProps;
  }

  const { products } = state.products;

  const productHandle = ownProps.handle;
  const product = find(products, {handle: productHandle});

  return {
    product
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchProductByHandle: handle => {
      dispatch(fetchProductByHandle(handle));
    },
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(Product);
